// @flow
import apiService from './auth-api-service';

class IntegrationsService {
  getIntegrations = (): Promise<> => {
    return apiService.get('/integrations');
  }

  getAllIntegrations = (): Promise<> => {
    return apiService.get('/integrations/all');
  }
}

export default new IntegrationsService();


// WEBPACK FOOTER //
// ./src/services/integrations-service.js